/* eslint-disable import/no-extraneous-dependencies */
// @ts-ignore
import { useLocation } from '@gatsbyjs/reach-router';
import React from 'react';
// @ts-ignore
import HelmetDatoCms from '../gatsby/sourcing/helmet';
const GlobalSeo = ({ globalData: data, pageContext }) => {
    const { pathname } = useLocation();
    const { titleSuffix, twitterAccount } = data.datoCmsSite?.globalSeo || {};
    const { title, description, image, twitterCard } = data.datoCmsSite?.globalSeo?.fallbackSeo || {};
    return (React.createElement(HelmetDatoCms, { htmlAttributes: { lang: pageContext?.datoLocale || 'en' }, favicon: data.datoCmsSite?.faviconMetaTags },
        React.createElement("title", null,
            title,
            titleSuffix),
        description && React.createElement("meta", { name: "description", content: description }),
        title && React.createElement("meta", { property: "og:title", content: title }),
        description && React.createElement("meta", { property: "og:description", content: description }),
        image?.url && React.createElement("meta", { property: "og:image", content: image?.url }),
        React.createElement("meta", { property: "og:locale", content: (pageContext?.datoLocale || 'en').replace('-', '_') }),
        React.createElement("meta", { property: "og:type", content: "website" }),
        React.createElement("meta", { property: "og:url", content: `${process.env.GATSBY_REAL_BASE_URL}${pathname}` }),
        twitterCard && React.createElement("meta", { name: "twitter:card", content: twitterCard }),
        twitterAccount && React.createElement("meta", { name: "twitter:creator", content: twitterAccount }),
        title && React.createElement("meta", { name: "twitter:title", content: title }),
        description && React.createElement("meta", { name: "twitter:description", content: description }),
        image?.url && React.createElement("meta", { name: "twitter:image", content: image?.url })));
};
export default GlobalSeo;
//# sourceMappingURL=global-seo.js.map